import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FormsService {

  constructor() { }

    findInvalidControls(f) {
        const invalid = [];

        const controls: any = f.controls;
        for (const name in controls) {
            if (controls[name].invalid) {
                if (controls[name].controls) {
                    const subControls = controls[name].controls;
                    for (const subName in subControls) {
                        if (subControls[subName].invalid) {
                            invalid.push(subName);
                        }
                    }
                } else {
                    invalid.push(name);
                }
            }
        }
        return invalid;
    }


}
